module.exports = __webpack_public_path__ + "img/icon_process_04.7d2142a3.svg";